import React, { useState, useEffect } from 'react'
import {
  Box,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}))

const BlurField = ({ value, onCommit, ...props }) => {
  const [local, setLocal] = useState(value || '')
  useEffect(() => { setLocal(value || '') }, [value])
  return (
    <TextField
      {...props}
      value={local}
      onChange={(e) => setLocal(e.target.value)}
      onBlur={() => { if (local !== (value || '')) onCommit(local) }}
    />
  )
}

const CoverEditor = ({ data, onChange }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Typography variant="subtitle2" gutterBottom>
        Cover Page Settings
      </Typography>

      <BlurField
        label="Subtitle"
        value={data.subtitle || ''}
        onCommit={(v) => onChange('subtitle', v)}
        size="small"
        variant="outlined"
        fullWidth
      />

      <BlurField
        label="Tagline"
        value={data.tagline || ''}
        onCommit={(v) => onChange('tagline', v)}
        size="small"
        variant="outlined"
        fullWidth
      />
    </Box>
  )
}

export default CoverEditor
